import { render } from "./LobbyPlayerContainer.vue?vue&type=template&id=99bfe3d0&scoped=true"
import script from "./LobbyPlayerContainer.vue?vue&type=script&lang=js"
export * from "./LobbyPlayerContainer.vue?vue&type=script&lang=js"

import "./LobbyPlayerContainer.vue?vue&type=style&index=0&id=99bfe3d0&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99bfe3d0"]])

export default __exports__